import { saveOrderPayPlanObjective,searchOrderPayPlanObjective,handleGetOrderPayPlanObjective, searchOrderSubCriteriaDefinition, deleteObjective, searchObjectiveList, searchObjectivePrimeList, getPayPlansDetails } from "@/store/services/objective/objectiveService";
import { getCriteriaList, getObjectivesList, getVendorsList, getVendorsRows, saveObejectiveSales, searchPayplanList } from "@/store/services/order/orderService";
import { ObjectiveState } from "@/types";
import { Module } from "vuex";
import i18n from "@/i18n";
import Notify from 'quasar/src/plugins/Notify.js';;

const objectiveModule: Module<ObjectiveState, unknown> = {
  namespaced: true,
  state: {
    isLoading: false,
    openObjective: false,
    objectiveFilterRef: "",
    vendorsList:[],
    selectedObjective: {
      reference:"",
      label: "",
      startPeriod: "",
      endPeriod: "",
      objectType: "odm.order.payplanobjective",
      systemUid: "odm-order",
      status: "",
      frequency: "",
      activity: "",
      displayOrder: null,
      basis:{},
      criterea: [],
      primes:[],
      eligibility: [],
      isIndividualObjective: true
    },
    mode: "create",
  },
  getters: {
    // Returns the default state for the objective form 
    defaultObjective() {
      return {
        reference: "",
        label: "",
        startPeriod: "",
        endPeriod: "",
        objectType: "odm.order.payplanobjective",
        systemUid: "odm-order",
        status: "",
        frequency: "",
        activity: "",
        basis: {},
        criterea: [],
        primes: [],
        eligibility: [],
        realisation: "",
        populationCriteria:"",
        isIndividualObjective: true
      };
    },
    initSelectedObjectif(){
      return {
        reference:"",
        label: "",
        startPeriod: "",
        endPeriod: "",
        objectType: "odm.order.payplanobjective",
        systemUid: "odm-order",
        status: "",
        frequency: "",
        activity: "",
        displayOrder: null,
        realisation: "",
        basis: {
          criteria: 
                {objectType: 'odm.order.criteriadefinition',
                systemUid: 'odm-order',
                resourceUid: ''},
          targetValue: "",
          targetValueType:{
                objectType: "odm.order.targetvaluetype",
                systemUid: "odm-order",
                resourceUid: "PERCENTAGE"
          },
          details: [
                  {
                    criteria:{
                      objectType: 'odm.order.criteriadefinition',
                      systemUid: 'odm-order',
                      resourceUid: ''
                    },
                      value: {
                          type: {
                              value: "",
                              label: ""
                          }
                      },
                      targetValue:"",
                      targetValueType:{
                        objectType: "odm.order.targetvaluetype",
                        systemUid: "odm-order",
                        resourceUid: "PERCENTAGE"
                      },
                      optionsList: []
                  }
              ],
              validated: true
          },
          criterea: [],
          primes: [],
          eligibility: [],
          isIndividualObjective: true
          
      
      }
    },
    getGeneralData: (state): ObjectiveState | undefined => {
      return state?.selectedObjective?.generalData;
    },
    getvendeurList: (state): ObjectiveState | undefined => {
   
      return state?.vendorsList?.items||[];
    },
    getObjectivesList: (state): ObjectiveState | undefined => {
   
      return state?.objectiveList?.items||[];
    },
    getCriteriaList: (state): ObjectiveState | undefined => {
   
      return state?.criteriaList||[];
    },
    getBrandModelInit(){
      return {
        criteria: {
          objectType: "odm.order.criteriadefinition",
          systemUid: "odm-order",
          resourceUid: ''
        },
          value: {
              type: {
                  value: "",
                  label: ""
              }
          },
          targetValue:"",
          targetValueType:{
            objectType: "odm.order.targetvaluetype",
            systemUid: "odm-order",
            resourceUid: "PERCENTAGE"
          },
          optionsList: []
      };
    },
    getBasisInit(){
      return {
        criteria:{
                objectType: 'odm.order.criteriadefinition',
                systemUid: 'odm-order',
                resourceUid: ''
              }
                ,
        criteriaValue:'',
        targetValueType:{
          objectType: "odm.order.targetvaluetype",
          systemUid: "odm-order",
          resourceUid: "PERCENTAGE"
      },
        details: [
          {
            criteria: {
              objectType: "odm.order.criteriadefinition",
              systemUid: "odm-order",
              resourceUid: ''
            },
            value: {
              type: {
                value: '',
                label: '',
              }
            },
            targetValue:"",
            targetValueType:{
                objectType: "odm.order.targetvaluetype",
                systemUid: "odm-order",
                resourceUid: "PERCENTAGE"
            },
            optionsList:[]
          }
        ],
        validated: false
      }
    },
    getCritereaInit() {
      return {
        criteria:{
          objectType: 'odm.order.criteriadefinition',
          systemUid: 'odm-order',
          resourceUid: ''
        },
        targetValue: "",
        targetValueType:{
          objectType: "odm.order.targetvaluetype",
          systemUid: "odm-order",
          resourceUid: "PERCENTAGE"
        },
        details: [
          {
            criteria:{
              objectType: 'odm.order.criteriadefinition',
              systemUid: 'odm-order',
              resourceUid: ''
            },
            value: {
              type: {
                value: '',
                label: '',
              }
            },
            targetValue:"",
            targetValueType:{
              objectType: "odm.order.targetvaluetype",
              systemUid: "odm-order",
              resourceUid: "PERCENTAGE"
            },
            optionsList:[]
          }
        ],
        validated: false
      }
    },
    getPrimesCritereaInit() {
      return {
        objectType: "odm.order.payplanobjectiveprime",
        systemUid: "odm-order",
        criteria: {
          objectType: 'odm.order.criteriadefinition',
          systemUid: 'odm-order',
          resourceUid: ''
        },
          brand: {
            objectType: 'odm.order.criteriadefinition',
            systemUid: 'odm-order',
            resourceUid: ''
          },
          model: {
                objectType: "odm.order.subcriteriadefinition",
                systemUid: "odm-order",
                resourceUid: ''
            },
          optionsList: [],
          details: [
              {
                  bloc: [
                      {
                        subCriteria: {
                          objectType: "odm.order.subcriteriadefinition",
                          systemUid: "odm-order",
                          resourceUid: ''
                        },
                        targetValueOperator:{
                          objectType: "odm.order.targetvalueoperator",
                          systemUid: "odm-order",
                          resourceUid: ''
                        },
                          targetValue: "",
                          targetValueType:{
                                    objectType: "odm.order.targetvaluetype",
                                    systemUid: "odm-order",
                                    resourceUid: "PERCENTAGE"
                          }
                      }
                  ],
                  primeBonus: {
                    amount: 0.0,
                    currency: "EUR"
                  }
              }
          ]
      }
    },
    getBlocInit() {
      return {
        subCriteria: {
          objectType: "odm.order.subcriteriadefinition",
          systemUid: "odm-order",
          resourceUid: ''
        },
        targetValueOperator:{
          objectType: "odm.order.targetvalueoperator",
          systemUid: "odm-order",
          resourceUid: ''
        },
        targetValue: "",
        targetValueType:{
          objectType: "odm.order.targetvaluetype",
          systemUid: "odm-order",
          resourceUid: "PERCENTAGE"
        }
      }
    },
    getPrimeInit() {
      return {
        bloc: [
            {
                subCriteria: {
                  objectType: "odm.order.subcriteriadefinition",
                  systemUid: "odm-order",
                  resourceUid: ''
                },
                targetValueOperator:{
                  objectType: "odm.order.targetvalueoperator",
                  systemUid: "odm-order",
                  resourceUid: ''
                } ,
                targetValue: "",
                targetValueType:{
                          objectType: "odm.order.targetvaluetype",
                          systemUid: "odm-order",
                          resourceUid: "PERCENTAGE"
                }
            }
        ],
        primeBonus: {
          amount: 0.0,
          currency: "EUR"
        }
      }
    },
    getMode(state){
      return state.mode
  },
  },
  actions: {
    initObjective({ commit,  getters }, payload) {
      const objective = getters.initSelectedObjectif
      commit('setObjective', objective);
      commit("showObjectiveDetail");
  },
    // Resets the selected objective to its default state
    ObjectiveDefaultState({ commit, getters }) {
      const objective = getters.defaultObjective
      commit('setObjective', objective);
    },
  saveOrderPayPlanObjective({ state, dispatch }, payload) {
    saveOrderPayPlanObjective(state.selectedObjective).then((res: any) => {
      if (payload && payload.callback) {
          payload.callback(res)
      }
      if(res?.resourceUid){
          Notify.create({
              message: i18n.global.t("order.payplan.messages.createSuccess"),
              color: "positive",
          }) 
      }else{
          Notify.create({
              message: 'ERROR: ' + res,
              color: 'negative'
          });
      }
    })
  },
  searchOrderPayPlanObjective({ commit }, payload) {
    const { filter,offset,limit, sort, callback } = payload
    searchOrderPayPlanObjective(filter,offset,limit,sort)
        .then((response:any) => callback(response))
        .catch((e:any) => console.error(e))
},
searchOrderSubCriteriaDefinition({ commit }, payload) {
  const { filter,offset,limit, callback } = payload
  searchOrderSubCriteriaDefinition(filter,offset,limit)
      .then((response:any) => callback(response))
      .catch((e:any) => console.error(e))
},
async initOrderPayPlanObjectiveEditMode({ commit}, payload) {
  const { resourceUid } = payload
  if (!resourceUid) {
      throw new Error('ResourceUid is mandatory!')
  }
  try {
      const orderPayPlanObjective = await handleGetOrderPayPlanObjective(resourceUid)
      commit('setObjective', orderPayPlanObjective);
      commit("showObjectiveDetail");
  } catch (e) {
      Notify.create({
          message: 'ERROR: ' + e,
          color: 'negative'
      })
  }
},
    showObjectiveDetail({ commit }, payload) {
        commit("showObjectiveDetail");
      },
      showScaleEdit({ commit }, payload) {
        commit("showObjectiveDetail");
      },
      removeCriterea({ commit }, payload) {
        commit("removeCriterea", payload)
    },
    vendorsList({ commit }, payload) {
      const { filter, callback } = payload;
      getVendorsList(filter)
        .then((res) => {
          console.log(res)
          commit("setVendorsList",res)
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    objectivesList({ commit }, payload) {
      const { filter, callback } = payload;
      getObjectivesList(filter)
        .then((res) => {
          commit("setObjectiveList",res)
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    getCriteriaList({ commit }) {
      getCriteriaList("criteriaObj")
        .then((res) => {
          commit("setCriteriaList",res)
        })
        .catch((e) => console.error(e));
    },
    searchPayPlanList({ commit }, payload) {
      const { filter,offset,limit, callback } = payload;
      searchPayplanList(filter,offset,limit)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    vendorsRows({commit},payload){
      const {filter,callback}=payload;
      getVendorsRows(filter).then((res) => {
        callback(res);
      })
      .catch((e) => console.error(e));

    },
    removeCritereaDetail({ commit }, payload) {
      commit("removeCritereaDetail", payload)
    },
      setCriterea({ commit }, payload) {
        commit("setCriterea", payload)
    },
    async deleteObjective({ commit }, payload) {
      // Si payload est un objet avec une clé 'payload', on l'extrait
      const data = payload.payload || payload;

      // Collecter tous les planId à supprimer
      const deletePromises: Promise<any>[] = [];

      console.log('Data reçue:', data); // Pour debug

      if (data.groupedByYear) {
        // Parcourir toutes les années
        Object.keys(data.groupedByYear).forEach((year) => {
          const yearData = data.groupedByYear[year];

          console.log(`Année ${year}:`, yearData); // Pour debug

          // Vérifier que vendeurs existe
          if (yearData && yearData.vendeurs) {
            // Parcourir tous les vendeurs
            Object.keys(yearData.vendeurs).forEach((vendeurId) => {
              const vendeur = yearData.vendeurs[vendeurId];

              // Vérifier que months existe
              if (vendeur && Array.isArray((data.frequency_code === "Quarterly" ? vendeur.quarters : vendeur.months))) {
                // Parcourir tous les mois
                const vendeursData = data.frequency_code === "Quarterly" ? vendeur.quarters : vendeur.months
                vendeursData.forEach((monthData: any) => {
                  if (monthData && monthData.planId) {
                    console.log('Ajout du planId:', monthData.planId); // Pour debug
                    deletePromises.push(
                      deleteObjective(monthData.planId)
                    );
                  }
                });
              }
            });
          }
        });
      }
      else {
        const yearData = data;
        if (yearData && yearData.vendeurs) {
          yearData.vendeurs.forEach((vendeur: any) => {
            if (vendeur && Array.isArray((yearData.period_type === "Quarterly" ? vendeur.quarters : vendeur.months))) {
              const vendeursData = yearData.period_type === "Quarterly" ? vendeur.quarters : vendeur.months
              vendeursData.forEach((monthData: any) => {
                if (monthData && monthData.planId) {
                  console.log('Ajout du planId:', monthData.planId); // Pour debug
                  deletePromises.push(
                    deleteObjective(monthData.planId)
                  );
                }
              });
            }
          })
          
        }
      }

      // Vérifier qu'il y a des objectifs à supprimer
      if (deletePromises.length === 0) {
        Notify.create({
          message: "Aucun objectif à supprimer",
          color: "info",
        });
        return;
      }

      console.log(`Suppression de ${deletePromises.length} objectifs...`);

      // Exécuter toutes les suppressions en parallèle
      try {
        await Promise.all(deletePromises)
        Notify.create({
          message: `${deletePromises.length} objectif(s) supprimé(s) avec succès`,
          color: "positive",
        });
      } catch (err: any) {
        console.error("Erreur lors de la suppression:", err);
        Notify.create({
          message: `Erreur: ${err.message || err}`,
          color: "negative",
        });
        throw err;
      }
    },
  async searchObjectiveList({ commit }, payload) {
      const { filter,offset,limit, callback } = payload;
       searchObjectiveList(filter,offset,limit)
        .then((res:any) => {
          callback(res);
        })
        .catch((e:any) => console.error(e));
    },
  async getPayPlansDetails({ commit }, payload) {
      const { filter,offset,limit, callback } = payload;
       getPayPlansDetails(filter,offset,limit)
        .then((res:any) => {
          callback(res);
        })
        .catch((e:any) => console.error(e));
    },
  async searchObjectivePrimeList({ commit }, payload) {
      const { filter,offset,limit, callback } = payload;
      await searchObjectivePrimeList(filter,offset,limit)
        .then((res:any) => {
          callback(res);
        })
        .catch((e:any) => console.error(e));
    },
    setMode({ commit }, payload) {
      commit('setMode', payload)
    },
  },
  mutations: {
    setObjective(state,payload){
      state.selectedObjective= {...payload}
    },
    showObjectiveDetail(state) {
        state.openObjective = !state.openObjective;
    },
    removeCriterea(state, payload) {
      const { index } = payload
      state.selectedObjective?.criterea?.splice(index, 1);
  },
  removeCritereaDetail(state, payload) {
      const { index,i } = payload
      state.selectedObjective?.criterea[index].details?.splice(i, 1);
  },
  setCriterea(state, payload) {
      state.selectedObjective.criterea = payload;
  },
  setVendorsList(state, payload) {
    console.log(payload)
    state.vendorsList = payload;
  },
  setObjectiveList(state, payload) {
    state.objectiveList = payload;
  },
  setCriteriaList(state, payload) {
    state.criteriaList = payload;
  },
  setMode(state,payload){
    state.mode = payload;
  },
  },
};

export default objectiveModule;
